"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDisabledDate = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var isDayOfWeekModifier = function (blackout) {
    return "daysOfWeek" in blackout;
};
var isBeforeModifier = function (blackout) {
    return "before" in blackout;
};
var isDisabledDate = function (date, dates) {
    for (var _i = 0, _a = Array.isArray(dates) ? dates : [dates]; _i < _a.length; _i++) {
        var blackout = _a[_i];
        if ((isDayOfWeekModifier(blackout) &&
            blackout.daysOfWeek.some(function (dayOfWeek) { return date.getDay() === dayOfWeek; })) ||
            (blackout instanceof Date && dayjs_1.default(date).isSame(blackout, "day")) ||
            (isBeforeModifier(blackout) &&
                dayjs_1.default(date).isBefore(blackout.before, "day"))) {
            return true;
        }
    }
    return false;
};
exports.isDisabledDate = isDisabledDate;
